/* src/app/depot-stock-location/pages/depot-stock-locations-edit/depot-stock-locations-edit.component.scss */
/*# sourceMappingURL=depot-stock-locations-edit.component.css.map */
